import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowOutOfBox: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-out-of-box, upload, share"><path d="M20.25 14.75V20.25H3.75V14.75M12 15V4.5M16.5 8.25L12 3.75L7.5 8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowOutOfBox;
